module.exports = __webpack_public_path__ + "1d7a3d98add376378cc0d22f5e90d46f.svg";